/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {PersonDrawer} from "./person-drawer";
import {CustomerDrawer} from "./customer-drawer";
import {DeviceDrawer} from "./device-drawer";
import {DeviceModelDrawer} from "./devicemodel-drawer";
import {UserDrawer} from "./user-drawer";
import {UploadDrawer} from "./upload-drawer";
import {PasswordDrawer} from "./password-drawer";
import {EventDrawer} from "./event-drawer";
import {ExamDrawer} from "./exam-drawer";
import {TodoDrawer} from "./todo-drawer";

export default function Drawers(props: any) {
    return (
        <>
            <UploadDrawer/>
            <PasswordDrawer/>
            <PersonDrawer/>
            <CustomerDrawer/>
            <DeviceDrawer/>
            <DeviceModelDrawer/>
            <UserDrawer/>
            <EventDrawer/>
            <ExamDrawer/>
            <TodoDrawer/>
        </>
    )
}